import axiosInstance from "../config/axios-config";
import {
  API_METHOD,
  permissionsGroups,
  STORAGE_KEY,
} from "../constants/constants";
import { jwtDecode } from "jwt-decode";
import { format, isValid } from "date-fns";
export const Client = async (method, url, body) => {
  try {
    let response = null;
    switch (method) {
      case API_METHOD.GET:
        response = await axiosInstance.get(url);
        break;
      case API_METHOD.POST:
        response = await axiosInstance.post(url, body);
        break;
      case API_METHOD.PUT:
        response = await axiosInstance.put(url, body);
        break;
      case API_METHOD.PATCH:
        response = await axiosInstance.patch(url, body);
        break;
      case API_METHOD.DELETE:
        response = await axiosInstance.delete(url);
        break;
      default:
        throw new Error("Invalid HTTP method");
    }
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      throw new Error(response.statusText || "Request failed");
    }
  } catch (error) {
    console.log(error, "axios error from helper client");
    if (error.response) {
      console.log(error.response.data, "axios error from helper client");
      // throw new Error({ message: error.message, response: null });
      throw error.response.data;
      // Include response data if available
      // throw { message: error.message, response: error.response };
    } else {
      throw { message: error.message, response: null };
    }
    // throw error.response || new Error("Network error");
  }
};

export const getItem = (key) => {
  const value = localStorage.getItem(key);

  if (!value || value === undefined) {
    return null;
  } else {
    const parsedValue = JSON.parse(value);
    return parsedValue;
  }
};

export const clearStorage = () => {
  localStorage.clear();
};

export const setItem = (key, value) => {
  localStorage.setItem(key, value);
};

export const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 3,
      }}
    >
      {" "}
      No
    </div>
  );
};

export const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingLeft: 3,
      }}
    >
      {" "}
      Yes
    </div>
  );
};

export const inputWrapperStyle = {
  position: "relative",
  display: "flex",
  alignItems: "center",
};

export const inputStyle = {
  paddingRight: "40px", // Adjust based on button width
};

export const buttonStyle = {
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translateY(-50%)",
  border: "none",
  background: "transparent",
  padding: "0 10px",
  cursor: "pointer",
  zIndex: 1,
};

export const getMediumType = (cellProps) => {
  if (cellProps === 2) {
    return "Packages";
  } else if (cellProps === 1) {
    return "Series";
  } else {
    return "Unknown type"; // optional: handle other cases if needed
  }
};
export const getPermissionGroupName = (id) => {
  const group = permissionsGroups.find((group) => group.id === parseInt(id));
  return group ? group.name : "Unknown";
};

export const getPostType = (cellProps) => {
  if (parseInt(cellProps) === 2) {
    return "Content-post";
  } else if (parseInt(cellProps) === 1) {
    return "Ad-post";
  } else {
    return "Unknown type"; // optional: handle other cases if needed
  }
};

export const getMediaType = (filename) => {
  const cleanFilename = filename.split("?")[0];
  const extension = cleanFilename.split(".").pop().toLowerCase();
  if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
    return "image";
  } else if (["mp4", "webm", "ogg"].includes(extension)) {
    return "video";
  } else if (["mp3", "wav", "ogg"].includes(extension)) {
    return "audio";
  }
  return "unknown";
};

export const isTokenExpired = () => {
  const token = localStorage.getItem(STORAGE_KEY.TOKEN);
  if (!token) return true;

  const decodedToken = jwtDecode(token);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp < currentTime;
};
const uuid = "676b0ff5-9cd8-4479-babf-0e6e79251d35";

// Convert UUID string to Base64
const base64Encoded = btoa(uuid);

// console.log(base64Encoded, "reset-password");

export const formatDate = (date) => {
  return isValid(date) ? format(date, "yyyy-MM-dd") : null;
};
export const handleInput = (e, regex) => {
  e.target.value = e.target.value.replace(regex, "");
};

export const capitalizeFirstLetter = (str) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

